module.exports = __webpack_public_path__ + "static/media/fixed_voice_error.2bf15843.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_error.svg
// module id = 3159
// module chunks = 0